import React from 'react';

import Icon from '-!svg-react-loader?name=Facebook!../../../images/icons/facebook.svg';

const Facebook = () => {
	return <Icon />;
};

export default Facebook;
